import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const UPDATE_WORKSPACE_USER_FOR_TABLE: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation updateWorkspaceUserForTable($input: UpdatePublisherByWorkspaceOwnerInput!) {
    updatePublisherByWorkspaceOwner(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
